import type { AdminUser } from '@/types'

type AdminIdentity = Partial<AdminUser> & {
  roleId?: string
  roleCode?: string
  role?: string
}

const normalizeRole = (value?: string): string =>
  value?.trim().toLowerCase().replace(/-/g, '_') ?? ''

export const isSuperadminIdentity = (user?: AdminIdentity | null): boolean => {
  if (!user) {
    return false
  }

  return [
    user.role_id,
    user.roleId,
    user.role_code,
    user.roleCode,
    user.role,
  ].some((role) => {
    const normalized = normalizeRole(role)
    return normalized === 'arl_superadmin' || normalized === 'superadmin'
  })
}

export const canResetAdminMfa = (
  currentUser: AdminIdentity | null | undefined,
  targetUser: AdminUser
): boolean =>
  isSuperadminIdentity(currentUser)
  && Boolean(currentUser?.id)
  && targetUser.id !== currentUser?.id
  && targetUser.is_mfa_enabled
